<app-widget-toolbar [widgetConfig]="widgetConfig"></app-widget-toolbar>
<div *ngIf="(!measurements || measurements.rows.length === 0) && !genericWidgetService.loading"
     class="no-data"><p>Brak danych z tego okresu!</p></div>
<app-mat-spinner-overlay *ngIf="genericWidgetService.loading" overlay="true"></app-mat-spinner-overlay>

<div id="divTableChart_{{ widgetConfig.id }}" class="table-chart"></div>
